import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
import messages from './messages';
export const Logout = () => (_jsx("div", { "data-testid": "logout-key", children: _jsx(FormattedMessage, { ...messages.logout }) }));
Logout.displayName = 'Logout';
